import { render, staticRenderFns } from "./CreateZone.vue?vue&type=template&id=b82099ae&"
import script from "./CreateZone.vue?vue&type=script&lang=js&"
export * from "./CreateZone.vue?vue&type=script&lang=js&"
import style0 from "./CreateZone.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports